var UserModel = /** @class */ (function () {
    function UserModel() {
    }
    UserModel.enableAgentColumnNameReplacement = function (user, c) {
        if (user && user.enableAgent) {
            if (c.name == 'operator') {
                c.title = 'Top Level Agent';
            }
            if (c.name == 'brand') {
                c.title = 'Super Agent';
            }
            if (c.name == 'brandTransactionId') {
                c.title = 'Super Agent Transaction';
            }
            if (c.name == 'playerStatus') {
                c.title = 'Super Agent Status';
            }
            if (c.name == 'playerId') {
                c.title = 'Super Agent Id';
            }
        }
    };
    return UserModel;
}());
export { UserModel };
var LotteryMarginCostsModel = /** @class */ (function () {
    function LotteryMarginCostsModel() {
    }
    return LotteryMarginCostsModel;
}());
export { LotteryMarginCostsModel };
var BrandsAndOperatorsForPopUpModel = /** @class */ (function () {
    function BrandsAndOperatorsForPopUpModel() {
    }
    return BrandsAndOperatorsForPopUpModel;
}());
export { BrandsAndOperatorsForPopUpModel };
var BaseBrand = /** @class */ (function () {
    function BaseBrand() {
    }
    return BaseBrand;
}());
export { BaseBrand };
export var InstantGameTypes;
(function (InstantGameTypes) {
    InstantGameTypes[InstantGameTypes["InstantGame"] = 1] = "InstantGame";
    InstantGameTypes[InstantGameTypes["Scratchcard"] = 2] = "Scratchcard";
})(InstantGameTypes || (InstantGameTypes = {}));
var BundleModel = /** @class */ (function () {
    function BundleModel() {
    }
    return BundleModel;
}());
export { BundleModel };
var SyndicateModel = /** @class */ (function () {
    function SyndicateModel() {
    }
    return SyndicateModel;
}());
export { SyndicateModel };
var BundleBrandLotteryModel = /** @class */ (function () {
    function BundleBrandLotteryModel() {
    }
    return BundleBrandLotteryModel;
}());
export { BundleBrandLotteryModel };
var LotteryModel = /** @class */ (function () {
    function LotteryModel() {
    }
    return LotteryModel;
}());
export { LotteryModel };
var LotteryJackpotDrawStatusModel = /** @class */ (function () {
    function LotteryJackpotDrawStatusModel() {
    }
    return LotteryJackpotDrawStatusModel;
}());
export { LotteryJackpotDrawStatusModel };
var LotteryJackpotDrawModel = /** @class */ (function () {
    function LotteryJackpotDrawModel() {
    }
    return LotteryJackpotDrawModel;
}());
export { LotteryJackpotDrawModel };
var PickModel = /** @class */ (function () {
    function PickModel() {
    }
    return PickModel;
}());
export { PickModel };
var OperatorModel = /** @class */ (function () {
    function OperatorModel() {
    }
    return OperatorModel;
}());
export { OperatorModel };
var BrandModel = /** @class */ (function () {
    function BrandModel() {
    }
    return BrandModel;
}());
export { BrandModel };
export var BrandNotificationTypes;
(function (BrandNotificationTypes) {
    BrandNotificationTypes[BrandNotificationTypes["API"] = 1] = "API";
    BrandNotificationTypes[BrandNotificationTypes["Email"] = 2] = "Email";
})(BrandNotificationTypes || (BrandNotificationTypes = {}));
export var HttpMethods;
(function (HttpMethods) {
    HttpMethods[HttpMethods["Get"] = 1] = "Get";
    HttpMethods[HttpMethods["Post"] = 2] = "Post";
})(HttpMethods || (HttpMethods = {}));
export var BodyTypes;
(function (BodyTypes) {
    BodyTypes[BodyTypes["Form"] = 1] = "Form";
    BodyTypes[BodyTypes["JSON"] = 2] = "JSON";
})(BodyTypes || (BodyTypes = {}));
export var InstantGamesHostingTypesEnum;
(function (InstantGamesHostingTypesEnum) {
    InstantGamesHostingTypesEnum[InstantGamesHostingTypesEnum["Spinola"] = 1] = "Spinola";
    InstantGamesHostingTypesEnum[InstantGamesHostingTypesEnum["Playport"] = 2] = "Playport";
})(InstantGamesHostingTypesEnum || (InstantGamesHostingTypesEnum = {}));
var GamePlayerModel = /** @class */ (function () {
    function GamePlayerModel() {
    }
    return GamePlayerModel;
}());
export { GamePlayerModel };
export var PlayerStatusEnum;
(function (PlayerStatusEnum) {
    PlayerStatusEnum[PlayerStatusEnum["Active"] = 1] = "Active";
    PlayerStatusEnum[PlayerStatusEnum["Blocked"] = 2] = "Blocked";
})(PlayerStatusEnum || (PlayerStatusEnum = {}));
var TransactionModel = /** @class */ (function () {
    function TransactionModel() {
    }
    return TransactionModel;
}());
export { TransactionModel };
export var StepEnum;
(function (StepEnum) {
    //Brand
    StepEnum[StepEnum["BrandBasicMeta"] = 0] = "BrandBasicMeta";
    StepEnum[StepEnum["BrandAnalytics"] = 1] = "BrandAnalytics";
    StepEnum[StepEnum["BrandTransactions"] = 2] = "BrandTransactions";
    StepEnum[StepEnum["BrandLotteries"] = 3] = "BrandLotteries";
    StepEnum[StepEnum["LotteryGrouping"] = 4] = "LotteryGrouping";
    StepEnum[StepEnum["BrandInstantGames"] = 5] = "BrandInstantGames";
    StepEnum[StepEnum["BrandSweepstakes"] = 6] = "BrandSweepstakes";
    StepEnum[StepEnum["BrandBundles"] = 7] = "BrandBundles";
    StepEnum[StepEnum["BrandLotteryInsurance"] = 8] = "BrandLotteryInsurance";
    StepEnum[StepEnum["BrandLotteryInsuranceCosts"] = 9] = "BrandLotteryInsuranceCosts";
    StepEnum[StepEnum["BrandPlayers"] = 10] = "BrandPlayers";
    StepEnum[StepEnum["BrandSettings"] = 11] = "BrandSettings";
    StepEnum[StepEnum["BrandSiteConfig"] = 12] = "BrandSiteConfig";
    StepEnum[StepEnum["BrandChangeLog"] = 13] = "BrandChangeLog";
    StepEnum[StepEnum["BrandBilling"] = 14] = "BrandBilling";
    StepEnum[StepEnum["BrandNotifications"] = 15] = "BrandNotifications";
    StepEnum[StepEnum["BrandRenderTheme"] = 16] = "BrandRenderTheme";
    StepEnum[StepEnum["BrandRenderLayout"] = 17] = "BrandRenderLayout";
    //Lottery
    StepEnum[StepEnum["LotteryBasicMeta"] = 18] = "LotteryBasicMeta";
    StepEnum[StepEnum["LotteryPriceTiers"] = 19] = "LotteryPriceTiers";
    StepEnum[StepEnum["LotteryAnalytics"] = 20] = "LotteryAnalytics";
    StepEnum[StepEnum["LotteryTransactions"] = 21] = "LotteryTransactions";
    StepEnum[StepEnum["LotteryBranding"] = 22] = "LotteryBranding";
    StepEnum[StepEnum["LotteryTickets"] = 23] = "LotteryTickets";
    StepEnum[StepEnum["LotteryTicketDiscounts"] = 24] = "LotteryTicketDiscounts";
    StepEnum[StepEnum["LotteryPlatformMargins"] = 25] = "LotteryPlatformMargins";
    StepEnum[StepEnum["LotteryChangeLog"] = 26] = "LotteryChangeLog";
    StepEnum[StepEnum["LotterySettings"] = 27] = "LotterySettings";
    StepEnum[StepEnum["LotteryFaq"] = 28] = "LotteryFaq";
    StepEnum[StepEnum["LotteryTicketLines"] = 29] = "LotteryTicketLines";
    StepEnum[StepEnum["BrandLotterySyndicates"] = 30] = "BrandLotterySyndicates";
    //LotteryBranding
    StepEnum[StepEnum["LotteryBrandingImages"] = 31] = "LotteryBrandingImages";
    StepEnum[StepEnum["LotteryBrandingColors"] = 32] = "LotteryBrandingColors";
    StepEnum[StepEnum["LotteryBrandingText"] = 33] = "LotteryBrandingText";
    //Player
    StepEnum[StepEnum["GamePlayerBasicMeta"] = 34] = "GamePlayerBasicMeta";
    StepEnum[StepEnum["GamePlayerChangeLog"] = 35] = "GamePlayerChangeLog";
    StepEnum[StepEnum["GamePlayerIpAddressLog"] = 36] = "GamePlayerIpAddressLog";
    StepEnum[StepEnum["GamePlayerKYC"] = 37] = "GamePlayerKYC";
    StepEnum[StepEnum["GamePlayerDetails"] = 38] = "GamePlayerDetails";
    StepEnum[StepEnum["GamePlayerTicketLines"] = 39] = "GamePlayerTicketLines";
    StepEnum[StepEnum["GamePlayerTicketDraws"] = 40] = "GamePlayerTicketDraws";
    StepEnum[StepEnum["GamePlayerTransactions"] = 41] = "GamePlayerTransactions";
    //Brand
    StepEnum[StepEnum["OverlayBranding"] = 42] = "OverlayBranding";
    StepEnum[StepEnum["LobbyBranding"] = 43] = "LobbyBranding";
    StepEnum[StepEnum["AssetsBranding"] = 44] = "AssetsBranding";
    StepEnum[StepEnum["HotLotteryBranding"] = 45] = "HotLotteryBranding";
    StepEnum[StepEnum["ResultsBranding"] = 46] = "ResultsBranding";
    StepEnum[StepEnum["PurchasesBranding"] = 47] = "PurchasesBranding";
    StepEnum[StepEnum["CartBranding"] = 48] = "CartBranding";
    //Operator
    StepEnum[StepEnum["OperatorBasicMeta"] = 49] = "OperatorBasicMeta";
    StepEnum[StepEnum["OperatorAnalytics"] = 50] = "OperatorAnalytics";
    StepEnum[StepEnum["OperatorBrands"] = 51] = "OperatorBrands";
    StepEnum[StepEnum["OperatorTransactions"] = 52] = "OperatorTransactions";
    StepEnum[StepEnum["OperatorPlayers"] = 53] = "OperatorPlayers";
    StepEnum[StepEnum["OperatorChangeLog"] = 54] = "OperatorChangeLog";
    StepEnum[StepEnum["OperatorBilling"] = 55] = "OperatorBilling";
    StepEnum[StepEnum["OperatorTicketLines"] = 56] = "OperatorTicketLines";
    StepEnum[StepEnum["OperatorSettings"] = 57] = "OperatorSettings";
    //Transaction
    StepEnum[StepEnum["TransactionTickets"] = 58] = "TransactionTickets";
    StepEnum[StepEnum["TransactionVideos"] = 59] = "TransactionVideos";
    //Ticket Lines
    StepEnum[StepEnum["TransactionOverview"] = 60] = "TransactionOverview";
    StepEnum[StepEnum["BrandAdsBranding"] = 61] = "BrandAdsBranding";
    StepEnum[StepEnum["BrandConfigBranding"] = 62] = "BrandConfigBranding";
    StepEnum[StepEnum["LotteryAdsBranding"] = 63] = "LotteryAdsBranding";
    //Ticket Draws
    StepEnum[StepEnum["TicketDrawsOverview"] = 64] = "TicketDrawsOverview";
    StepEnum[StepEnum["WinningNominationClaimBasicMeta"] = 65] = "WinningNominationClaimBasicMeta";
    //Bundle
    StepEnum[StepEnum["BundleBasicMeta"] = 66] = "BundleBasicMeta";
    StepEnum[StepEnum["BundleBranding"] = 67] = "BundleBranding";
    StepEnum[StepEnum["BundleAssets"] = 68] = "BundleAssets";
    StepEnum[StepEnum["BundleTickets"] = 69] = "BundleTickets";
    StepEnum[StepEnum["BundleTicketDiscounts"] = 70] = "BundleTicketDiscounts";
    StepEnum[StepEnum["BundleChangeLog"] = 71] = "BundleChangeLog";
    StepEnum[StepEnum["BundleTicketLines"] = 72] = "BundleTicketLines";
    StepEnum[StepEnum["BundleAdsBranding"] = 73] = "BundleAdsBranding";
    //Syndicate
    StepEnum[StepEnum["SyndicateBasicMeta"] = 74] = "SyndicateBasicMeta";
    StepEnum[StepEnum["SyndicateBranding"] = 75] = "SyndicateBranding";
    StepEnum[StepEnum["SyndicateAssets"] = 76] = "SyndicateAssets";
    StepEnum[StepEnum["SyndicateTickets"] = 77] = "SyndicateTickets";
    StepEnum[StepEnum["SyndicateTicketDiscounts"] = 78] = "SyndicateTicketDiscounts";
    StepEnum[StepEnum["SyndicateChangeLog"] = 79] = "SyndicateChangeLog";
    StepEnum[StepEnum["SyndicateTicketLines"] = 80] = "SyndicateTicketLines";
    StepEnum[StepEnum["SyndicateAdsBranding"] = 81] = "SyndicateAdsBranding";
    //InstantGames
    StepEnum[StepEnum["InstantGameBranding"] = 82] = "InstantGameBranding";
    StepEnum[StepEnum["InstantGameAdsBranding"] = 83] = "InstantGameAdsBranding";
    StepEnum[StepEnum["InstantGameBasicMeta"] = 84] = "InstantGameBasicMeta";
    StepEnum[StepEnum["InstantGamePriceTiers"] = 85] = "InstantGamePriceTiers";
    StepEnum[StepEnum["InstantGameTicketPrices"] = 86] = "InstantGameTicketPrices";
    StepEnum[StepEnum["InstantGameTicketDiscounts"] = 87] = "InstantGameTicketDiscounts";
    StepEnum[StepEnum["InstantGameChangeLog"] = 88] = "InstantGameChangeLog";
    StepEnum[StepEnum["InstantGameTicketLines"] = 89] = "InstantGameTicketLines";
    StepEnum[StepEnum["InstantGameTickets"] = 90] = "InstantGameTickets";
    //Appsettings
    StepEnum[StepEnum["AppSettingsBasicMeta"] = 91] = "AppSettingsBasicMeta";
    //Sweepstakes
    StepEnum[StepEnum["SweepstakeBasicMeta"] = 92] = "SweepstakeBasicMeta";
    StepEnum[StepEnum["SweepstakePrizeTiers"] = 93] = "SweepstakePrizeTiers";
    StepEnum[StepEnum["SweepstakeDraws"] = 94] = "SweepstakeDraws";
    StepEnum[StepEnum["SweepstakeChangeLog"] = 95] = "SweepstakeChangeLog";
    StepEnum[StepEnum["SweepstakeTicketPrices"] = 96] = "SweepstakeTicketPrices";
    StepEnum[StepEnum["SweepstakeTicketDiscounts"] = 97] = "SweepstakeTicketDiscounts";
    StepEnum[StepEnum["SweepstakeTickets"] = 98] = "SweepstakeTickets";
    StepEnum[StepEnum["SweepstakeBrandSettings"] = 99] = "SweepstakeBrandSettings";
    StepEnum[StepEnum["BrandRenderEditor"] = 100] = "BrandRenderEditor";
})(StepEnum || (StepEnum = {}));
var LotteryBrandDiscountModel = /** @class */ (function () {
    function LotteryBrandDiscountModel() {
    }
    return LotteryBrandDiscountModel;
}());
export { LotteryBrandDiscountModel };
var BrandLotteryGroupModel = /** @class */ (function () {
    function BrandLotteryGroupModel() {
    }
    return BrandLotteryGroupModel;
}());
export { BrandLotteryGroupModel };
var LotteryBrandPriceModel = /** @class */ (function () {
    function LotteryBrandPriceModel() {
    }
    return LotteryBrandPriceModel;
}());
export { LotteryBrandPriceModel };
var CurrencyRateModel = /** @class */ (function () {
    function CurrencyRateModel() {
    }
    return CurrencyRateModel;
}());
export { CurrencyRateModel };
var CurrencyModel = /** @class */ (function () {
    function CurrencyModel() {
        this.isSelected = false;
    }
    return CurrencyModel;
}());
export { CurrencyModel };
var GamePlayerTicketDrawModel = /** @class */ (function () {
    function GamePlayerTicketDrawModel() {
    }
    return GamePlayerTicketDrawModel;
}());
export { GamePlayerTicketDrawModel };
var GamePlayerTicketLineModel = /** @class */ (function () {
    function GamePlayerTicketLineModel() {
    }
    return GamePlayerTicketLineModel;
}());
export { GamePlayerTicketLineModel };
export var TicketStatusEnum;
(function (TicketStatusEnum) {
    TicketStatusEnum[TicketStatusEnum["New"] = 1] = "New";
    TicketStatusEnum[TicketStatusEnum["LineRemoved"] = 2] = "LineRemoved";
    TicketStatusEnum[TicketStatusEnum["AddedToCart"] = 3] = "AddedToCart";
    TicketStatusEnum[TicketStatusEnum["PurchasedFromCart"] = 4] = "PurchasedFromCart";
    TicketStatusEnum[TicketStatusEnum["DirectPurchase"] = 5] = "DirectPurchase";
    TicketStatusEnum[TicketStatusEnum["BonusTicket"] = 6] = "BonusTicket";
})(TicketStatusEnum || (TicketStatusEnum = {}));
export var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum[CurrencyEnum["Euro"] = 1] = "Euro";
})(CurrencyEnum || (CurrencyEnum = {}));
export var CurrencyCodeEnum;
(function (CurrencyCodeEnum) {
    CurrencyCodeEnum["Eur"] = "EUR";
    CurrencyCodeEnum["Inr"] = "INR";
})(CurrencyCodeEnum || (CurrencyCodeEnum = {}));
var ApiSettingModel = /** @class */ (function () {
    function ApiSettingModel() {
    }
    return ApiSettingModel;
}());
export { ApiSettingModel };
var TemplateNames = /** @class */ (function () {
    function TemplateNames() {
    }
    TemplateNames.Template1 = "template-1";
    TemplateNames.Template2 = "template-2";
    TemplateNames.Template3 = "template-3";
    TemplateNames.Template4 = "template-4";
    TemplateNames.Template5 = "template-5";
    TemplateNames.Template6 = "template-6";
    TemplateNames.Template7 = "template-7";
    TemplateNames.Template8 = "template-8";
    TemplateNames.Template9 = "template-9";
    TemplateNames.Template10 = "template-10";
    TemplateNames.Template11 = "template-11";
    return TemplateNames;
}());
export { TemplateNames };
export var LotteryFeedCodeEnum;
(function (LotteryFeedCodeEnum) {
    LotteryFeedCodeEnum["Feed"] = "";
    LotteryFeedCodeEnum["RNG"] = "RNG";
    LotteryFeedCodeEnum["RngPick3"] = "RNGPICK3";
})(LotteryFeedCodeEnum || (LotteryFeedCodeEnum = {}));
export var LotteryFeedEnum;
(function (LotteryFeedEnum) {
    LotteryFeedEnum[LotteryFeedEnum["Feed"] = 1] = "Feed";
    LotteryFeedEnum[LotteryFeedEnum["RNG"] = 2] = "RNG";
    LotteryFeedEnum[LotteryFeedEnum["RngPick3"] = 3] = "RngPick3";
})(LotteryFeedEnum || (LotteryFeedEnum = {}));
export var LotteryJackpotDrawStatusEnum;
(function (LotteryJackpotDrawStatusEnum) {
    LotteryJackpotDrawStatusEnum[LotteryJackpotDrawStatusEnum["NA"] = 1] = "NA";
    LotteryJackpotDrawStatusEnum[LotteryJackpotDrawStatusEnum["ActionRequired"] = 2] = "ActionRequired";
    LotteryJackpotDrawStatusEnum[LotteryJackpotDrawStatusEnum["ResultsToReview"] = 3] = "ResultsToReview";
    LotteryJackpotDrawStatusEnum[LotteryJackpotDrawStatusEnum["EmailSentToReview"] = 4] = "EmailSentToReview";
    LotteryJackpotDrawStatusEnum[LotteryJackpotDrawStatusEnum["ResultsReviewed"] = 5] = "ResultsReviewed";
    LotteryJackpotDrawStatusEnum[LotteryJackpotDrawStatusEnum["ActionRequiredEmailSent"] = 6] = "ActionRequiredEmailSent";
})(LotteryJackpotDrawStatusEnum || (LotteryJackpotDrawStatusEnum = {}));
export var GameListEnum;
(function (GameListEnum) {
    GameListEnum["Lottery"] = "Lottery";
    GameListEnum["InstantGame"] = "InstantGame";
    GameListEnum["Bundle"] = "Bundle";
})(GameListEnum || (GameListEnum = {}));
export var borderColor;
(function (borderColor) {
    borderColor["orange"] = "1px solid orange";
    borderColor["red"] = "1px solid red";
})(borderColor || (borderColor = {}));
export var WinningAmountTypeEnum;
(function (WinningAmountTypeEnum) {
    WinningAmountTypeEnum[WinningAmountTypeEnum["Static"] = 1] = "Static";
    WinningAmountTypeEnum[WinningAmountTypeEnum["DynamicByContribution"] = 2] = "DynamicByContribution";
})(WinningAmountTypeEnum || (WinningAmountTypeEnum = {}));
/// ***** Sweepstakes related contracts ends here *****//
